import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons";

import { colors } from "UI/colors";

DeleteUserButton.propTypes = {
  onClick: PropTypes.func,
};

export default function DeleteUserButton({ onClick }) {
  return (
    <DeleteButton onClick={onClick} role="button">
      <FontAwesomeIcon icon={faTrashAlt} />
    </DeleteButton>
  );
}

const DeleteButton = styled.div`
  cursor: pointer;
  margin-left: 10px;
  margin-right: 5px;
  flex-shrink: 0;
  color: #b7b7b7;
  transition: color 200ms;

  &:hover {
    color: ${colors.fnRed};
  }
`;
